import React, { useState, useEffect } from 'react';
import {
    StyleSheet,
    Image,
    FlatList,
    View,
    TouchableOpacity,
    Platform,
    ScrollView,
    ImageBackground,
} from 'react-native';
import { useSelector } from 'react-redux';
import Screen from './../components/shared/Screen';
import TblShowDariaftha from './../components/shared/TblShowDariaftha';
import ToplearnText from './../components/shared/ToplearnText';
import CustomButton from './../components/shared/CustomButton';
import { getKholasehVaziat, getDariaftha } from './../actions/index';
import { loadingToast } from '../utils/toasts';
import Toast from 'react-native-tiny-toast';
import { useDispatch } from 'react-redux';

const DariaftihaScreen = () => {
    const dispatch = useDispatch();
    const kholasehVaziat = useSelector((state) => state.kholasehVaziats);
    const defaultColor = 'gray';
    const selectColor = 'tomato';
    const [selectItem, setSelectItem] = useState(1);

    useEffect(() => {
        try {
            const fetchData = async () => {
                loadingToast('در حال بارگذاری...');
                dispatch(
                    getDariaftha({
                        hesab:
                            kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].hesab
                                : 0,
                    })
                );
                Toast.hide();
            };
            fetchData();
        } catch (err) {
            console.log(err);
            Toast.hide();
        }
    }, [kholasehVaziat]);

    const brdsts = useSelector((state) => state.dariafthas);
    let brdst = brdsts;
    switch (selectItem) {
        case 2:
            brdst = brdsts.filter((x) => x.brdAdi > 0);
            break;
        case 3:
            brdst = brdsts.filter((x) => x.brdZarori > 0);
            break;
        case 4:
            brdst = brdsts.filter((x) => x.brdKargoshaie > 0);
            break;
        case 5:
            brdst = brdsts.filter((x) => x.brdTavalod > 0);
            break;
        case 6:
            brdst = brdsts.filter((x) => x.brdTasvieh > 0);
            break;
        default:
            break;
    }
    return (
        <Screen style={styles.container}>
            <Image
                blurRadius={2}
                style={styles.headerImage}
                source={require('../assets/dariaft.jpg')}
            />
            <View style={styles.header}>
                <ToplearnText
                    fontFamily="yekan"
                    size="2"
                    // color="#fff"
                >
                    دریافتی ها
                </ToplearnText>
                <ToplearnText
                    fontFamily="yekan"
                    size="1.5"
                    // color="#fff"
                >
                    {kholasehVaziat.length !== 0
                        ? kholasehVaziat[0].firstName
                        : '-'}{' '}
                    {kholasehVaziat.length !== 0
                        ? kholasehVaziat[0].lastName
                        : '-'}
                </ToplearnText>
                <View style={styles.imgHeaderTXTfilter}>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 1
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(1);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            همه
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 2
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(2);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            عادی
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 3
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(3);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            ضروری
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 4
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(4);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            کارگشایی
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 5
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(5);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            هدیه تولد
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 6
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(6);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            تسویه
                        </ToplearnText>
                    </TouchableOpacity>
                </View>
            </View>
            {Platform.OS === 'web' ? (
                <ScrollView style={styles.fltlstStyle}>
                    <FlatList
                        data={brdst}
                        keyExtractor={(brd) => brd._id.toString()}
                        renderItem={({ item }) => (
                            <TblShowDariaftha
                                shomarehFish={
                                    item.shomarehFish ? item.shomarehFish : 0
                                }
                                tarikhPardakht={
                                    item.tarikhPardakht
                                        ? item.tarikhPardakht
                                        : 0
                                }
                                mablaghKol={
                                    item.mablaghKol ? item.mablaghKol : 0
                                }
                                brdAdi={item.brdAdi ? item.brdAdi : 0}
                                brdKargoshaie={
                                    item.brdKargoshaie ? item.brdKargoshaie : 0
                                }
                                brdZarori={item.brdZarori ? item.brdZarori : 0}
                                brdTasvieh={
                                    item.brdTasvieh ? item.brdTasvieh : 0
                                }
                                brdBazprdkhtKomak={
                                    item.brdBazprdkhtKomak
                                        ? item.brdBazprdkhtKomak
                                        : 0
                                }
                                brdTavalod={
                                    item.brdTavalod ? item.brdTavalod : 0
                                }
                                brdHazinehJari={
                                    item.brdHazinehJari
                                        ? item.brdHazinehJari
                                        : 0
                                }
                                brdTozihat={
                                    item.brdTozihat ? item.brdTozihat : 0
                                }
                            />
                        )}
                    />
                </ScrollView>
            ) : (
                <View style={styles.fltlstStyle}>
                    <FlatList
                        data={brdst}
                        keyExtractor={(brd) => brd._id.toString()}
                        renderItem={({ item }) => (
                            <TblShowDariaftha
                                shomarehFish={
                                    item.shomarehFish ? item.shomarehFish : 0
                                }
                                tarikhPardakht={
                                    item.tarikhPardakht
                                        ? item.tarikhPardakht
                                        : 0
                                }
                                mablaghKol={
                                    item.mablaghKol ? item.mablaghKol : 0
                                }
                                brdAdi={item.brdAdi ? item.brdAdi : 0}
                                brdKargoshaie={
                                    item.brdKargoshaie ? item.brdKargoshaie : 0
                                }
                                brdZarori={item.brdZarori ? item.brdZarori : 0}
                                brdTasvieh={
                                    item.brdTasvieh ? item.brdTasvieh : 0
                                }
                                brdBazprdkhtKomak={
                                    item.brdBazprdkhtKomak
                                        ? item.brdBazprdkhtKomak
                                        : 0
                                }
                                brdTavalod={
                                    item.brdTavalod ? item.brdTavalod : 0
                                }
                                brdHazinehJari={
                                    item.brdHazinehJari
                                        ? item.brdHazinehJari
                                        : 0
                                }
                                brdTozihat={
                                    item.brdTozihat ? item.brdTozihat : 0
                                }
                            />
                        )}
                    />
                </View>
            )}
        </Screen>
    );
};

export default DariaftihaScreen;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    headerImage: {
        width: '98%',
        resizeMode: 'cover',
        borderRadius: 15,
        height: Platform.OS === 'web' ? 160 : 90,
        marginBottom: 20,
    },
    header: {
        position: 'absolute',
        width: '98%',
        padding: 5,
        alignItems: 'center',
    },
    fltlstStyle: {
        width: '95%',
    },
    button: {
        borderRadius: 13,
        justifyContent: 'center',
        alignItems: 'center',
        width: '15%',
        height: Platform.OS === 'web' ? '95%' : '55%',
        padding: 5,
        margin: 5,
    },
    imgHeaderTXTfilter: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginTop: 10,
    },
});
